import { render, staticRenderFns } from "./DrawerTemp.vue?vue&type=template&id=4f38be8b&scoped=true"
import script from "./DrawerTemp.vue?vue&type=script&lang=js"
export * from "./DrawerTemp.vue?vue&type=script&lang=js"
import style0 from "./DrawerTemp.vue?vue&type=style&index=0&id=4f38be8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38be8b",
  null
  
)

export default component.exports